import { useState } from "react";
import { assetUrl } from "@/lib/api";
import { useSettings } from "@/context/SettingsContext";

export const LogoMark = ({ className = "h-9 w-9" }) => (
  <svg viewBox="0 0 48 48" fill="none" className={className} aria-hidden="true">
    <defs>
      <linearGradient id="cp-grad" x1="4" y1="4" x2="44" y2="44" gradientUnits="userSpaceOnUse">
        <stop stopColor="#38BDF8" />
        <stop offset="1" stopColor="#6366F1" />
      </linearGradient>
    </defs>
    <circle cx="24" cy="24" r="11" fill="url(#cp-grad)" />
    <circle cx="19.5" cy="20.5" r="3.4" fill="#0B0F17" opacity="0.35" />
    <ellipse cx="24" cy="24" rx="21" ry="7.5" stroke="url(#cp-grad)" strokeWidth="2.4" transform="rotate(-18 24 24)" />
    <circle cx="40.5" cy="14.5" r="2.8" fill="#38BDF8" />
  </svg>
);

export const Logo = ({ dark = false }) => {
  const { settings } = useSettings();
  const { company_name, logo_url } = settings?.brand || {};
  const [broken, setBroken] = useState(false);
  if (logo_url && !broken) {
    return (
      <img
        src={assetUrl(logo_url)}
        alt={company_name || "Cyber Planet"}
        className="h-9 w-auto object-contain"
        data-testid="header-logo-image"
        onError={() => setBroken(true)}
      />
    );
  }
  return (
    <span className="flex items-center gap-2.5">
      <LogoMark className="h-8 w-8" />
      <span className={`font-display text-base font-bold tracking-[0.08em] ${dark ? "text-ink" : "text-white"}`}>
        {((company_name || "CYBER PLANET")).toUpperCase()}
      </span>
    </span>
  );
};
